module.exports = __webpack_public_path__ + "images/graphic-footer_7335956d4fc00704088879c1060a26b1.png";